import React, { useState, useContext, useEffect, useRef } from "react";

//Material
import { Grid, IconButton, Icon } from "@material-ui/core";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";

//OurComponents
import HeaderModule from "../../../components/header/HeaderModule";
import Card from "../../../components/cards/Card";
import Btn from "../../../components/buttons/Btn";
import TableDefault from "../../../components/grid/TableDefault";
import Loading from "../../../components/basics/Loading";
import TextFieldErp from "../../../components/basics/TextFieldErp";

// Assets
import DefaultProductImage from "../../../assets/imgs/default.png";

import { makeStyles } from "@material-ui/core";

import Swal from "sweetalert2";

import {
  PedidoContainer,
  DataAria,
  MainContent,
  ImageAria,
  Finaliza,
  Form,
  BtnLine,
  BtnGrid,
  Separator,
  IconCustom,
  CustomGrid,
  CustomPaper,
} from "./styles/VendaRapida";

// Children
import ModalVRFReceber from "./children/ModalVRFReceber";
import SearchDialog from "../../../patterns/modals/SearchDialog";

//Controller (functions)
import useVendaRapidaController from "./controllers/VendaRapidaController";
import {
  VendaRapidaContext,
  VendaRapidaContextProvider,
} from "./contexts/VendaRapidaContext";
import { findProdutosAlternativeFormatted } from "../../../repositories/qerpapi/erp/estoque/v1/ProdutosRepository";
import { QueryParamsContext } from "../../../context/QueryParamsContext";
import { findVendedores } from "../../../repositories/qerpapi/erp/vendas/v1/VendedoresRepository";
import SearchSelect from "../../../components/inputs/SearchSelect";
import { notify } from "../../../utils/notify";
import MaskService from "../../../utils/mask/maskService";
import { findCliente } from "../../../repositories/qerpapi/erp/prouser/v1/ClienteRepository";
import EmptySearchDialog from "../../../patterns/modals/EmptySearchDialog";
import { findProdutosAlternativeFlat } from "../../../repositories/qerpapi/erp/estoque/v1/formatters/ProdutoFormatters";

const useStyles = makeStyles({
  CustomGridItem: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
  },
  CustomCard: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
  },
  CustomGrid: {
    justifyContent: "space-between",
    flexDirection: "column",
  },
});

let typingTimer = null;

const View = ({ location }) => {
  const {
    handleSelectSeller,
    handleSelectClient,
    handleSelectProduct,
    handleAddTableRows,
    handleUpdatedValue,
    handleDisableButton,
    handleDeleteTableRows,
    handleOpenFinishModal,
    handleChangeProductCode,
    handleChangeClientCpf,
    handleChangeSellerCode,
    handleCalcItemsDiscount,
    handleClientObject,
    handleProductObject,
    handleSellerObject,
    handleSelectCaixa,
    verificaEstoqueSobConsulta,
    changeUStoBR,
    handleClientMethopPayment,
    handleInitScreen,
  } = useVendaRapidaController();

  const {
    sellerCode,
    sellerName,
    setSellerName,
    productPrice,
    setProductPrice,
    productQuantity,
    setProductQuantity,
    productImage,
    tableRows,
    orderTotal,
    setOrderTotal,
    updatedValue,
    setUpdatedValue,
    productDiscount,
    setProductDiscount,
    disabledAddButton,
    modalFinishOpen,
    sellerErrors,
    clientErrors,
    productCodeAux,
    productCode,
    setProductCode,
    itemsDiscount,
    setItemsDiscount,
    setSelectedPaymentMethod,
    selectedPaymentType,
    setPaymentMethods,
    dialogSelectCaixaOpen,
    setDialogSelectCaixaOpen,
    sellerInfos,
    setSellerInfos,
    sellerCodeAux,
    productInfos,
    setProductInfos,
    clientInfos,
    setClientInfos,
    clientCpfAux,
    setProductCodeAux,
    setClientCpfAux,
    isLoading,
    setIsLoading,
    userMaximumDiscountPercentage,
  } = useContext(VendaRapidaContext);

  const { queryParams } = useContext(QueryParamsContext);

  const [modalVendedorOpen, setModalVendedorOpen] = useState(false);
  const [modalClientOpen, setModalClientOpen] = useState(false);
  const [modalProductOpen, setModalProductOpen] = useState(false);
  const [dataContent, setDataContent] = useState([]);

  const productCodeRef = useRef(null);
  const cpfRef = useRef(null);
  const qtdeRef = useRef(null);
  const sellerCodeRef = useRef(null);

  const handleProductFocus = () => {
    productCodeRef.current.focus();
  };

  const handleSellerCodeFocus = () => {
    sellerCodeRef.current.focus();
  };

  const handleAddButtonClick = () => {
    handleAddTableRows();
    handleProductFocus();
  };

  const handleChangeQuantity = (e) => {
    handleUpdatedValue();
    setProductQuantity(e.target.value);
  };

  // Ambos useCallbacks que escutam um objeto e setam os valores nos campos necessários;
  useEffect(() => {
    handleSellerObject();
  }, [sellerInfos, handleSellerObject]);

  useEffect(() => {
    handleProductObject();
  }, [productInfos, handleProductObject]);

  useEffect(() => {
    handleClientObject();
  }, [clientInfos, handleClientObject]);

  useEffect(() => {
    handleClientMethopPayment();
  }, [clientInfos, handleClientMethopPayment]);

  // <----->

  useEffect(() => {
    handleCalcItemsDiscount();
  }, [handleCalcItemsDiscount]);

  useEffect(() => {
    handleSellerCodeFocus();
  }, []);

  useEffect(() => {
    handleUpdatedValue();
  }, [handleUpdatedValue]);

  useEffect(() => {
    handleDisableButton();
  }, [handleDisableButton]);

  useEffect(() => {
    handleInitScreen({
      setDataModalCaixa: setDataContent,
      setDataContent,
    });
  }, [handleInitScreen]);

  // useEffect utilizado para o "ModalVRFreceber"
  useEffect(() => {
    setPaymentMethods(
      selectedPaymentType?.empresasformaspgto.filter(
        (el) => el.st_ativo === "S"
      ) ?? []
    );
    setSelectedPaymentMethod(
      selectedPaymentType?.empresasformaspgto?.find((method) => {
        return (
          method.descricao?.includes("A VISTA") ||
          method.descricao?.includes("1x")
        );
      }) ||
        selectedPaymentType?.empresasformaspgto[0] ||
        null
    );
  }, [selectedPaymentType, setPaymentMethods, setSelectedPaymentMethod]);

  useEffect(() => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(async () => {
      let error = false;

      try {
        setIsLoading(true);

        if (clientCpfAux) {
          const callback = await findCliente({
            empresa_cnpj: queryParams.empresa_cnpj,
            where: {
              cpfcnpj: clientCpfAux.replace(/[^0-9]+/g, ""),
              ativo: "S",
            },
          });

          if (callback.success && callback.data) {
            const filtered = callback.data.find(
              (e) =>
                e.cpfcnpj === clientCpfAux ||
                e.cpfcnpj === clientCpfAux.replace(/[^0-9]+/g, "")
            );

            filtered ? setClientInfos(filtered) : (error = true);

            if (error) {
              setClientCpfAux("");
              setClientInfos(null);
              notify(
                `Cliente com CPF/CNPJ '${clientCpfAux}' não
              encontrado ou o mesmo se encontra inativo.`
              );
            }
          }
        }
      } catch (e) {
        console.error("Erro ao buscar cliente por CPF.");
      } finally {
        setIsLoading(false);
      }
    }, 1500);
  }, [
    clientCpfAux,
    queryParams,
    setClientCpfAux,
    setClientInfos,
    setIsLoading,
  ]);

  useEffect(() => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(async () => {
      try {
        if (productCodeAux !== "") {
          setIsLoading(true);

          let callback = await findProdutosAlternativeFormatted({
            empresa_cnpj: queryParams.empresa_cnpj,
            include: "produtosfotos",
            where: { codeBar: productCodeAux, active: "SIM" },
          });

          if (callback.success && callback.data.length) {
            let resultRequest = callback.data.find(
              (product) =>
                productCodeAux === product.codigo ||
                productCodeAux === product.codbarras_codigoalternativo
            );

            if (verificaEstoqueSobConsulta(resultRequest?.estoques)) return;

            setProductInfos(resultRequest);
          } else {
            Swal.fire({
              icon: "error",
              text: "Produto não encontrado ou inativo.",
            }).then(() => {
              handleProductFocus();
              setProductCode("");
              setProductInfos(null);
              return;
            });
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    }, 1500);
  }, [
    productCodeAux,
    queryParams,
    setIsLoading,
    setProductCodeAux,
    setProductInfos,
    setProductCode,
    verificaEstoqueSobConsulta,
  ]);

  useEffect(() => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(async () => {
      if (!sellerCodeAux) return;

      try {
        setIsLoading(true);

        const callback = await findVendedores({
          empresa_cnpj: queryParams.empresa_cnpj,
          id: sellerCodeAux,
        });

        if (callback.data && callback.data.ativo === "S")
          setSellerInfos(callback.data);
        else {
          setSellerInfos(null);
          notify(
            `Nenhum vendedor com código '${sellerCodeAux}'
              encontrado ou o mesmo se encontra inativo.`
          );
        }
      } catch (e) {
      } finally {
        setIsLoading(false);
      }
    }, 1500);
  }, [sellerCodeAux, queryParams, setSellerInfos, setIsLoading]);

  // Columns
  const columnsTableProduct = [
    // { label: "Codigo" },
    { label: "Descrição", id: "descricao" },
    { label: "Qtd.", id: "qtd" },
    {
      label: "Valor Unit.",
      id: "precovenda",
    },
    { label: "Desc. Item", id: "descvalor" },
    { label: "Total", id: "valortotal" },
    {
      label: "Ações",
      format: (value) => {
        return (
          <>
            <IconButton
              onClick={() =>
                handleDeleteTableRows(
                  value.index,
                  value.valortotal,
                  value.precovenda
                )
              }
            >
              <Icon>delete</Icon>
            </IconButton>
          </>
        );
      },
    },
  ];

  const columnsCaixaTerminal = [{ label: "Nome", id: "descricao" }];

  const columnsSellersModal = [
    { label: "Código", id: "id" },
    { label: "Nome", id: "nomevendedor" },
  ];

  const columnsClientModal = [
    { label: "CPF/CNPJ", id: "cpfcnpj" },
    { label: "Nome", id: "razao" },
  ];

  const columnsProductsModal = [
    { label: "CÓD.", id: "id" },
    { label: "Código de Barras", id: "codigo" },
    { label: "Descrição", id: "descricaoresumida" },
    {
      label: "Preço",
      id: "precovenda",
      format: (value) => {
        if (queryParams.paramprecoestoqueunico === "SIM") {
          return value.precovenda
            ? `R$ ${MaskService.toMask("decimal", value.precovenda)}`
            : "-";
        } else
          return value.estoques[0]?.precovenda
            ? `R$ ${changeUStoBR(value.estoques[0]?.precovenda)}`
            : "-";
      },
    },
    {
      label: "Código Adicional",
      id: "codbarras_codigoalternativo",
      format: (item) =>
        item.codbarras_codigoalternativo
          ? item.codbarras_codigoalternativo
          : "-",
    },
    {
      label: "Qtd. Venda Cod. Adicional",
      id: "qtdvenda_codigoalternativo",
      format: (item) =>
        item.qtdvenda_codigoalternativo ? item.qtdvenda_codigoalternativo : "-",
    },
    {
      label: "Desc. Cod. Adicional",
      id: "perc_desc_codigoalternativo",
      format: (item) =>
        item.perc_desc_codigoalternativo
          ? `% ${item.perc_desc_codigoalternativo}`
          : "-",
    },
  ];

  const classes = useStyles();

  const { CustomGridItem, CustomCard } = classes;

  // View
  return (
    <>
      <Loading open={isLoading} />
      {dialogSelectCaixaOpen && (
        <EmptySearchDialog
          disabledSearch
          disabledCancelButton
          open={dialogSelectCaixaOpen}
          setOpen={setDialogSelectCaixaOpen}
          columns={columnsCaixaTerminal}
          selectable={true}
          multiSelect={false}
          handleMainClick={handleSelectCaixa}
          title="SELECIONE O CAIXA"
          dataContent={dataContent}
        />
      )}
      {modalVendedorOpen && (
        <SearchDialog
          open={modalVendedorOpen}
          setOpen={setModalVendedorOpen}
          columns={columnsSellersModal}
          selectable={true}
          multiSelect={false}
          handleMainClick={handleSelectSeller}
          route="vendas/vendedores/v1"
          title="VENDEDORES"
          where={{ ativo: "S" }}
        />
      )}
      {modalClientOpen && (
        <SearchDialog
          open={modalClientOpen}
          setOpen={setModalClientOpen}
          columns={columnsClientModal}
          selectable={true}
          multiSelect={false}
          handleMainClick={handleSelectClient}
          route="prouser/clientes/v1"
          title="CLIENTES"
          where={{ ativo: "S" }}
        />
      )}
      {modalProductOpen && (
        <SearchDialog
          open={modalProductOpen}
          setOpen={setModalProductOpen}
          columns={columnsProductsModal}
          handleRequestArray={findProdutosAlternativeFlat}
          selectable={true}
          multiSelect={false}
          handleMainClick={handleSelectProduct}
          route="estoque/produtos/v1/porcodigobarrauniao"
          rawUrl="include=produtosfotos&active=SIM"
          urlFilters="description,productId,codeBar"
          title="PRODUTOS"
          rowId={"descricao_final"}
          timeout={3000}
        />
      )}
      {modalFinishOpen && (
        <ModalVRFReceber
          setModalProdutosOpen={handleOpenFinishModal}
          modalProdutosOpen={modalFinishOpen}
          handleProductFocus={handleProductFocus}
        />
      )}
      <HeaderModule title="VENDAS - Pedido Rápido" />
      <PedidoContainer maxWidth="xl">
        <MainContent>
          <Grid container spacing={2}>
            <Grid item container md={12} lg={6}>
              <Card
                fullWidth
                line="left"
                lineColor="primary"
                className="AdjustedFlex"
              >
                <DataAria>
                  <Form>
                    <Grid container spacing={2}>
                      {queryParams.idversao === "16" ? (
                        <>
                          <Grid item xs={10} sm={5} lg={4}>
                            <TextFieldErp
                              label="Código"
                              size="small"
                              value={sellerCode}
                              onChange={handleChangeSellerCode}
                              error={sellerErrors.sellerCode ? true : false}
                              helperText={sellerErrors.sellerCode || ""}
                              inputRef={sellerCodeRef}
                              disabled
                            />
                          </Grid>
                          <Grid item xs={10} sm={7} lg={8}>
                            <TextFieldErp
                              label="Vendedor"
                              size="small"
                              value={sellerName}
                              setValue={setSellerName}
                              error={sellerErrors.sellerName ? true : false}
                              helperText={sellerErrors.sellerName || ""}
                              disabled
                            />
                          </Grid>
                        </>
                      ) : (
                        <>
                          <Grid item xs={10} sm={5} lg={4}>
                            <TextFieldErp
                              label="Código"
                              size="small"
                              value={sellerCode}
                              onChange={handleChangeSellerCode}
                              error={sellerErrors.sellerCode ? true : false}
                              helperText={sellerErrors.sellerCode || ""}
                              inputRef={sellerCodeRef}
                            />
                          </Grid>
                          <Grid item xs={10} sm={6} lg={7}>
                            <SearchSelect
                              descriptionField="apelido"
                              label="Vendedor"
                              setValue={setSellerInfos}
                              route="vendas/vendedores/v1"
                              filter="nomevendedor"
                              error={sellerErrors.sellerName ? true : false}
                              helperText={sellerErrors.sellerName || ""}
                              value={sellerInfos ?? null}
                              where={{ ativo: "S" }}
                            />
                          </Grid>
                          <BtnGrid
                            className="Exception"
                            xs={2}
                            item
                            sm={1}
                            lg={1}
                          >
                            <Btn
                              label={<IconCustom>search</IconCustom>}
                              bgcolor="blue"
                              hovercolor="primary"
                              full="true"
                              onClick={() => setModalVendedorOpen(true)}
                              sameWidth
                            />
                          </BtnGrid>
                        </>
                      )}
                      <Separator />
                      <Grid item xs={10} sm={5} lg={4}>
                        <TextFieldErp
                          label="CPF/CNPJ"
                          value={clientCpfAux}
                          onChange={handleChangeClientCpf}
                          error={clientErrors.clientCpf ? true : false}
                          helperText={clientErrors.clientCpf || ""}
                          inputRef={cpfRef}
                        />
                      </Grid>
                      <Grid item xs={10} sm={6} lg={7}>
                        <SearchSelect
                          descriptionField="apelido"
                          label="Cliente"
                          value={clientInfos}
                          setValue={setClientInfos}
                          route="prouser/clientes/v1"
                          filter="razao,apelido"
                          where={{ ativo: "S" }}
                        />
                      </Grid>
                      <BtnGrid item xs={2} sm={1} lg={1}>
                        <Btn
                          label={<IconCustom>search</IconCustom>}
                          bgcolor="blue"
                          hovercolor="primary"
                          full="true"
                          onClick={() => setModalClientOpen(true)}
                          sameWidth
                        />
                      </BtnGrid>
                      <Separator />
                      <ImageAria>
                        <Grid container spacing={2} justifyContent="center">
                          <Grid item lg={4}>
                            <CustomPaper>
                              {productImage ? (
                                <img
                                  src={`https://qerp-public.s3.sa-east-1.amazonaws.com/${productImage}`}
                                  alt=""
                                />
                              ) : (
                                <img src={DefaultProductImage} alt="" />
                              )}
                            </CustomPaper>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            lg={8}
                            className={CustomGridItem}
                          >
                            <Grid container spacing={2}>
                              <Grid item xs={10} sm={5} lg={12}>
                                <TextFieldErp
                                  label="Código de Barras"
                                  size="small"
                                  value={productCode}
                                  onChange={handleChangeProductCode}
                                  inputRef={productCodeRef}
                                />
                              </Grid>
                              <CustomGrid item xs={10} sm={6} lg={11}>
                                <SearchSelect
                                  descriptionField="descricao_final"
                                  label="Descrição"
                                  value={productInfos}
                                  setValue={setProductInfos}
                                  handleRequestArray={
                                    findProdutosAlternativeFlat
                                  }
                                  onChange={(objectEvent) => {
                                    if (
                                      !verificaEstoqueSobConsulta(
                                        objectEvent?.estoques
                                      )
                                    )
                                      setProductInfos(objectEvent);
                                  }}
                                  route="estoque/produtos/v1/porcodigobarrauniao"
                                  rawUrl="include=produtosfotos&active=SIM"
                                  urlFilters="description"
                                  filter="descricao,descricaoresumida"
                                />
                              </CustomGrid>
                              <BtnGrid
                                className="Exception"
                                item
                                xs={2}
                                sm={1}
                                lg={1}
                              >
                                <Btn
                                  label={<IconCustom>search</IconCustom>}
                                  bgcolor="blue"
                                  hovercolor="primary"
                                  full="true"
                                  onClick={() => setModalProductOpen(true)}
                                  sameWidth
                                />
                              </BtnGrid>
                              <Separator />
                              <Grid item xs={12} sm={4} lg={3}>
                                <TextFieldErp
                                  label="QTDE"
                                  size="small"
                                  value={productQuantity}
                                  setValue={setProductQuantity}
                                  type="number"
                                  InputProps={{ min: 1 }}
                                  onChange={handleChangeQuantity}
                                  inputRef={qtdeRef}
                                />
                              </Grid>
                              <Grid item xs={12} sm={4} lg={4}>
                                <TextFieldErp
                                  label="Vlr. Unit."
                                  size="small"
                                  value={productPrice}
                                  setValue={setProductPrice}
                                  mask="decimal"
                                  decimals={4}
                                />
                              </Grid>
                              <Grid item xs={12} sm={4} lg={5}>
                                <TextFieldErp
                                  label="Desconto Unit."
                                  size="small"
                                  mask="decimal"
                                  disabled={
                                    userMaximumDiscountPercentage === "0,00"
                                  }
                                  value={productDiscount}
                                  setValue={setProductDiscount}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </ImageAria>
                      <Grid item xs={12} lg={8}>
                        <TextFieldErp
                          label="Valor Atualizado R$"
                          size="small"
                          variant="filled"
                          className="UpdatedValue"
                          disabled
                          value={updatedValue}
                          setValue={setUpdatedValue}
                          mask="decimal"
                          textAlignRight
                        />
                      </Grid>
                      <Grid item lg={4}>
                        <Btn
                          label="Adicionar"
                          startIcon={<IconCustom>add </IconCustom>}
                          bgcolor="blue"
                          hovercolor="primary"
                          full="true"
                          disabled={disabledAddButton}
                          onClick={handleAddButtonClick}
                        />
                      </Grid>
                    </Grid>
                  </Form>
                </DataAria>
              </Card>
            </Grid>
            <Grid item container className={classes.CustomGrid} md={12} lg={6}>
              <TableDefault
                columns={columnsTableProduct}
                values={tableRows}
                tableTitle=""
                maxHeight="45vh"
                stickyHeader
                disabledTab
                smallFont
              />
              <Card fullWidth className={CustomCard}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4} lg={4}>
                    <TextFieldErp
                      label="Total de Desconto R$"
                      size="small"
                      color="primary"
                      variant="filled"
                      value={itemsDiscount || "0,00"}
                      setValue={setItemsDiscount}
                      className="DiscountItens"
                      disabled
                      mask="decimal"
                      textAlignRight
                    />
                  </Grid>
                  <Grid item xs={12} sm={8} lg={8}>
                    <TextFieldErp
                      label="Valor Total R$"
                      size="small"
                      variant="filled"
                      value={orderTotal || "0,00"}
                      setValue={setOrderTotal}
                      className="Highlighted"
                      disabled
                      mask="decimal"
                      textAlignRight
                    />
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </MainContent>
        <Finaliza>
          <Grid container spacing={2}>
            <BtnLine>
              <Btn
                label="Receber"
                startIcon={<MonetizationOnIcon />}
                bgcolor="primary"
                hovercolor="orange"
                full="true"
                onClick={() => handleOpenFinishModal()}
              />
            </BtnLine>
          </Grid>
        </Finaliza>
      </PedidoContainer>
    </>
  );
};

const VendaRapida = ({ ...props }) => (
  <VendaRapidaContextProvider>
    <View {...props} />
  </VendaRapidaContextProvider>
);

export default VendaRapida;
